import Checkbox from './checkbox.vue'
import Radio from './radio.vue'
import Text from './text.vue'
import Select from './select.vue'
import Icon from './icon.vue'

export default { Checkbox, Radio, Text, Select, Icon }
